import * as React from "react";
const SvgFiRrFileMedicalAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M6.5 16H1a1 1 0 0 1 0-2h4.965l1.703-2.555a.99.99 0 0 1 .894-.443c.356.022.673.232.833.551l2.229 4.459 1.044-1.566c.186-.278.498-.445.832-.445H18a1 1 0 0 1 0 2h-3.965l-1.703 2.555a1 1 0 0 1-.832.445q-.032 0-.062-.002a1 1 0 0 1-.833-.551l-2.229-4.459-1.044 1.566A1 1 0 0 1 6.5 16M22 10.485V19c0 2.757-2.243 5-5 5H7c-2.757 0-5-2.243-5-5a1 1 0 0 1 2 0c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-8.515q0-.245-.023-.485H15c-1.654 0-3-1.346-3-3V2.023A5 5 0 0 0 11.515 2H7C5.346 2 4 3.346 4 5v6a1 1 0 0 1-2 0V5c0-2.757 2.243-5 5-5h4.515c1.87 0 3.627.728 4.95 2.05l3.485 3.485a6.95 6.95 0 0 1 2.05 4.95M19.341 8a5 5 0 0 0-.805-1.05l-3.485-3.485a5 5 0 0 0-1.05-.805v4.341c0 .551.449 1 1 1z"
    />
  </svg>
);
export default SvgFiRrFileMedicalAlt;
